/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, July 7th 2022, 9:34:26 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Stack from "@mui/material/Stack";
import { EmailServerTipButton } from "portals/components/EmailServerTipButton";
import { NotificationTemplateList } from "service-builder/components/notifications/NotificationTemplateList";

export const TaskNotificationSettings = () => {
  return (
    <>
      <Stack>
        <div style={{ marginLeft: "auto" }}>
          <EmailServerTipButton />
        </div>
      </Stack>
      <NotificationTemplateList />
    </>
  );
};
